// Debug authentication - run in browser console
import { fetchAuthSession } from 'aws-amplify/auth';

window.debugAuth = async () => {
  try {
    console.log('=== Auth Debug ===');
    
    const session = await fetchAuthSession();
    console.log('Session:', session);
    
    const accessToken = session.tokens?.accessToken;
    const idToken = session.tokens?.idToken;
    
    console.log('Access Token:', accessToken ? 'Present' : 'Missing');
    console.log('ID Token:', idToken ? 'Present' : 'Missing');
    
    if (accessToken) {
      console.log('Access Token String:', accessToken.toString().substring(0, 50) + '...');
    }
    
    if (idToken) {
      console.log('ID Token String:', idToken.toString().substring(0, 50) + '...');
      
      // Decode JWT payload (just for debugging)
      try {
        const payload = JSON.parse(atob(idToken.toString().split('.')[1]));
        console.log('ID Token Payload:', payload);
      } catch (e) {
        console.log('Could not decode ID token payload');
      }
    }
    
    // Test API call
    const token = idToken?.toString() || accessToken?.toString();
    if (token) {
      console.log('Testing API call...');
      
      const response = await fetch('https://oauth.remote-assistant.ai/oauth/business-lookup', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          business_name: 'Test Business',
          address: 'Test Address'
        })
      });
      
      console.log('API Response Status:', response.status);
      console.log('API Response Headers:', Object.fromEntries(response.headers.entries()));
      
      if (response.status !== 200) {
        const text = await response.text();
        console.log('API Response Body:', text);
      }
    }
    
  } catch (error) {
    console.error('Debug error:', error);
  }
};

console.log('Auth debug loaded. Run window.debugAuth() to test.');